import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toArray, isObjectEmpty, buildUniqueArrayFromField} from '../../../Utils';
import {pipe, map, filter, sort, toTime, toTimeType} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    function getTableData(){    
        const {summaryData, classData, programs} = pageState;
        if(isObjectEmpty(summaryData)) return;
        
        let classIDList = buildUniqueArrayFromField(toArray(summaryData), 'classID');
        let classList = pipe(
            map(classID => classData[classID]),
            filter(classRec => classRec),
            sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() === b.Classname.toUpperCase() ? -1 : 0)),
        )(classIDList); 

        classList = classList.map(classRec => {
            let studentData = classRec.students.sort((a, b) => 
                (a.Name.toUpperCase() < b.Name.toUpperCase()) ? -1 : (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : 0
            );

            let studIDList = buildUniqueArrayFromField(toArray(summaryData), 'StudentID');
            let programsPerStudent = studIDList.map( studID => { return {studID,  // iterate all student ids         
                progs: summaryData.filter( summaryRec => // group all students with the same id
                    summaryRec.StudentID === studID).map(studentRec => { return { // translate stud array - prog array                    
                            title: (studentRec.ProgID.toUpperCase() in programs)?programs[studentRec.ProgID.toUpperCase()].title:'Removed Lesson',
                            time: parseInt(studentRec.CumulativeTime) + parseInt(studentRec.CumulativeIdleTime),
                            correct: studentRec.QuestionsRight + ' / ' + studentRec.QuestionsAttempted,
                            percent: Math.round((parseInt(studentRec.QuestionsRight)/parseInt(studentRec.QuestionsAttempted))*100),
                            QuestionsRight: parseInt(studentRec.QuestionsRight),
                            QuestionsAttempted: parseInt(studentRec.QuestionsAttempted),
                            logins: 1
                        };
                }).reduce((acc, item) => { // merge dulicates
                    let found = (acc.find(e => e.title === item.title));
                    !found && acc.push(item);
                    if(found){
                        found.QuestionsRight += item.QuestionsRight;
                        found.QuestionsAttempted += item.QuestionsAttempted;
                        found.time += item.time; 
                        found.correct = found.QuestionsRight + ' / ' + found.QuestionsAttempted;
                        found.percent = Math.round(found.QuestionsRight/found.QuestionsAttempted*100);
                        found.logins ++;
                    }
                    return acc;
                }
                ,[])
                };
            }).reduce((obj, item) => { // create a dictionary of studIDs and program lists
                obj[item.studID] = {progs:item.progs,
                    combined: item.progs.reduce((acc, progRec)=>{
                        acc.QuestionsRight += progRec.QuestionsRight;
                        acc.QuestionsAttempted += progRec.QuestionsAttempted;
                        acc.time += progRec.time; 
                        acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
                        acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
                        acc.logins += progRec.logins;
                        return acc;
                    },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0})
                };
                return obj; 
            },{});         

            studentData = studentData.filter( studentRec => // only care about students with marks
                studIDList.indexOf(studentRec.StudentID) > -1
            );

            studentData = studentData.map( studentRec => { 
                return {...studentRec, programData: [...programsPerStudent[studentRec.StudentID].progs], combinedData: programsPerStudent[studentRec.StudentID].combined};
            });

            return { classData: classRec, studData: studentData };
        });
        return classList;   
    }
    
    return <><ProgramsStudentsClassesComp tableData={getTableData()} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const ProgramsStudentsClassesComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col  style={{textAlign: 'left'}} xs='4'>Students</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Logins</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions Correct</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Percent</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}
            {tableData.map((classRec, class_i) => <span key={class_i}>
                <Row><Col xs='12' style={{fontWeight:'bold', backgroundColor:'lightgrey'}} >{classRec.classData.Classname}</Col></Row>
                {titleRow}
                <hr/>
                {classRec.studData.map((StudentRec, stud_i) => <span key={stud_i}>
                    <Row><Col xs='12' style={{fontWeight:'bold'}} >{StudentRec.Name}</Col></Row>
                    {StudentRec.programData.map((programRec, prog_i) => 
                        <ProgramRow key={prog_i} data={programRec} fontWeight={'normal'}/>
                    )}
                    <ProgramRow data={{name:'', logins: StudentRec.combinedData.logins, correct: StudentRec.combinedData.correct, percent:StudentRec.combinedData.percent, time:StudentRec.combinedData.time}} fontWeight={'bold'}/>
                    </span>
                )}
                </span>
            )}

            <Row><Col xs='12'></Col></Row>
            <ProgramRow data={{title: 'Total', logins: totals.logins, correct: totals.correct, percent:totals.percent, time:totals.time}} fontWeight={'bold'}/>

        </Container>
    );
};
ProgramsStudentsClassesComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const { title, logins, correct, percent, time} = props.data;

    return (
        <Row>
            <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='4'>{title}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{logins}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{correct}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{isNaN(percent)?'-':`${percent}%`}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(time)} {toTimeType(time)}</Col>
        </Row>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
